import { useEffect, useState } from "react";
import { getDonations } from "../../../api/apiServices";


export default function DonationDashboard() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDonations();
  }, []);

  const fetchDonations = async () => {
    try {
      const res = await getDonations();
      setDonations(res.data);
    } catch (error) {
      console.error("Failed to fetch donations", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading donations...</p>;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Donations</h2>

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Donor</th>
            <th className="p-2 border">Amount</th>
            <th className="p-2 border">Type</th>
            <th className="p-2 border">Status</th>
            <th className="p-2 border">Date</th>
          </tr>
        </thead>
        <tbody>
          {donations.map((donation) => (
            <tr key={donation._id}>
              <td className="p-2 border">
                {donation.firstName} {donation.lastName}
              </td>
              <td className="p-2 border">
                ₦{donation.amount.toLocaleString()}
              </td>
              <td className="p-2 border">{donation.donationType}</td>
              <td className="p-2 border">
                <span
                  className={`px-2 py-1 rounded text-white ${
                    donation.status === "completed"
                      ? "bg-green-500"
                      : donation.status === "failed"
                      ? "bg-red-500"
                      : "bg-yellow-500"
                  }`}
                >
                  {donation.status}
                </span>
              </td>
              <td className="p-2 border">
                {new Date(donation.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
